import React from "react";
import { Row } from "antd";
import { useNavigate } from "react-router";
import { useGetRole } from "../../generic/hooks/useGetRole";
import { RoleToLinkMapper } from "../../utils/UrlUtils";
import NoDataMessageComponent from "../../../components/generic/nodatamessage/NoDataMessageComponent";
import VolunteerCard from "./VolunteerCard";
import "./reportingLogDataList.css";

const NO_DATA_MESSAGE = "No data found!";

const PATIENT_REPORTING_TABLE_KEY = "patientReporting";

const ReportingLogDataList = ({ cellModalData, tableKey }) => {
  const role = useGetRole();
  const navigate = useNavigate();
  const isPatientData = tableKey === PATIENT_REPORTING_TABLE_KEY;

  const handleNavigation = (identifier) => {
    const base = RoleToLinkMapper(role);
    const path = isPatientData
      ? `${base}patient-profile?identifier=${identifier}`
      : `${base}volunteer-profile?identifier=${identifier}`;
    navigate(path);
  };

  if (!cellModalData?.length) {
    return <NoDataMessageComponent text={NO_DATA_MESSAGE} />;
  }

  return (
    <div className="reporting-log-data-list">
      <Row gutter={[16, 16]}>
        {cellModalData.map((item, index) => (
          <VolunteerCard
            key={item?.workforceIdentifier ?? item?.userIdentifier ?? index}
            item={item}
            index={index}
            onNavigate={handleNavigation}
            isPatient={isPatientData}
          />
        ))}
      </Row>
    </div>
  );
};

export default ReportingLogDataList;
